import React, { forwardRef } from 'react'
import { NavigateOptions, useNavigate } from 'react-router-dom'
import './button.css'

// UTILITIES
import { flatten } from '@utils/string-helper'
import Spinner from '@components/atoms/spinner'


interface ButtonProps extends React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> {
    to?: string
    navOptions?: NavigateOptions
    size?: "icon" | "small" | "medium" | "large"
    theme?: "primary" | "secondary" | "dark" | "light"
    companyColor?: string
    blueBorder?: boolean
    loading?: boolean
}

const Button = forwardRef<HTMLButtonElement, ButtonProps>((props, ref) => {
    const { className: classProps, children, disabled, loading = false, onClick: onClickProps, to, navOptions, type = "button", size = "medium", theme = "primary", blueBorder = false, ...buttonProps } = props
    const className = flatten(size, theme, loading ? 'loading' : '', blueBorder ? "blue-border" : "", "button", classProps)
    const navigate = useNavigate()

    function handleClick(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
        if (loading) return
        if (onClickProps) onClickProps(e);
        if (to) navigate(to, navOptions)
    }

    return (
        <button ref={ref} className={className} type={type} onClick={handleClick} disabled={disabled || loading} {...buttonProps}>
            {loading ? (
                <span className='button-loading-content'>
                    <Spinner indicator='circle' type={theme === 'primary' || theme === 'dark' ? 'light' : 'standard'} className='button-spinner' />
                    <span>{children}</span>
                </span>
            ) : children}
        </button>
    )
})

export default Button
